import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/feature/SectionHeading';
import { articles } from '@/mocks/articles';

export default function HotDig() {
  const featured = articles.filter((a) => a.featured).slice(0, 3);
  const [lead, ...rest] = featured;

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="Today"
            title="今日热扒"
            desc="编辑部根据讨论热度与信息完整度，每天挑出最值得深读的三条线索。"
          />
          <Link
            to="/topics"
            className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            查看全部专题
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="lg:row-span-2">{lead && <ArticleCard article={lead} variant="feature" />}</div>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-1">
            {rest.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}